<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">{{ 'SHOP-SELLER-BATCH.LIST.TITLE' | translate }}</h1>

  <!-- Error message -->
<!--  <div *ngIf="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">-->
<!--    {{ error }}-->
<!--  </div>-->
  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <!-- Loading indicator for initial load -->
  @if (paginationState().loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!paginationState().loading && batches.length > 0) {
    <div class="overflow-x-auto">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.ID' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.FILE_NAME' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.ROW_COUNT' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.EXECUTION_STATUS' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.USER' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.PROC_START' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'SHOP-SELLER-BATCH.LIST.PROC_END' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
        </thead>
        <tbody>
          @for (batch of batches; track batch.id; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.fileName }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.rowCount }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.successNum }} / {{ batch.failedNum }} ({{ batch.executedNum }})</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ batch.userEmail || ('SYSTEM' | translate) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ formatDate(batch.startProcessingTime) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ formatDate(batch.endProcessingTime) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <a class="flex items-center justify-center underline" [routerLink]="['/batch-shop-sellers/batch', batch.id]">
                  <i class="btn rounded-md flex items-center justify-center gap-2 bg-white border-black hover:bg-black hover:text-white dark:bg-black dark:border-white dark:hover:bg-white dark:hover:text-black py-1 px-3 text-sm" [innerHTML]="'eye' | feather: { width: 16, height: 16 }"></i>
                </a>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8">{{ 'PAGINATION.NO_ITEMS' | translate }}</td>
            </tr>
          }
        </tbody>
      </table>

      <app-pagination [paginationState]="paginationState()" [onPaginationChange]="onPageChange"></app-pagination>
    </div>
  }
</div>
